import script from "./BusinessHandlingGrowthTrend.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessHandlingGrowthTrend.vue?vue&type=script&setup=true&lang=js"

import "./BusinessHandlingGrowthTrend.vue?vue&type=style&index=0&id=fda2d510&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fda2d510"]])

export default __exports__